import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { PrismCheckboxComponent } from '@shure/prism-angular-components';

export interface CheckboxCellData {
	rowId: string;
	selected: boolean;
}

export interface CheckboxRendererParent {
	onCheckboxChange: (event: boolean, id: string) => void;
}

interface CheckboxRendererComponentContext {
	componentParent: CheckboxRendererParent;
}

export type CheckboxRendererComponentParams = ICellRendererParams<
	object,
	CheckboxCellData,
	CheckboxRendererComponentContext
>;

@Component({
	selector: 'sh-checkbox-renderer',
	standalone: true,
	templateUrl: './checkbox-renderer.component.html',
	styleUrl: './checkbox-renderer.component.scss',
	imports: [CommonModule, PrismCheckboxComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
	public params!: CheckboxRendererComponentParams;

	public agInit(params: CheckboxRendererComponentParams): void {
		this.params = params;
	}

	public refresh(params: CheckboxRendererComponentParams): boolean {
		this.params = params;
		return false;
	}

	public onCheckboxChange(event: boolean): void {
		this.params.context.componentParent.onCheckboxChange(event, this.params.value?.rowId ?? '');
	}
}
